angular
	.module 'App.Module.ReasonCode', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'reason_codes',
				url: '/reason_codes',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@reason_codes":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'ReasonCodeSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Stock.Stock'
					searchParams:
						repositoryName: 'ReasonCodeRepository'
						title: 'reason.codes'
						itemTemplate: '@app/reason-code/reason-code.search-result.view.html'

			.state 'reason_codes.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					reasonCode: (ReasonCodeRepository, $stateParams) ->
						return ReasonCodeRepository.getEntity($stateParams.id)

			.state 'reason_codes.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'ReasonCodeController'
						controllerAs: 'vm'
						templateUrl: '@app/reason-code/reason-code.view.html'
